export default "__VITE_ASSET__9d316364__"